export default __webpack_public_path__ + "static/bottom-1-72baf54defddc0e3764f0205a2b79389.png";